<template>
  <div>
    <h2 class="reports__title">Reports</h2>

    <table class="reports__table">
      <thead>
        <tr>
          <th>Description</th>
          <th>Subject</th>
          <th>Duration</th>
          <th>Date</th>
          <th>Student(s)</th>
        </tr>
      </thead>
      <tr v-for="a in activities" :key="a.id">
        <td>{{ a.description }}</td>
        <td>
          <span v-for="subjectId in a.subject" :key="subjectId">
            {{ getSubjectName(subjectId) }}
          </span>
        </td>
        <td>{{ a.duration }}min</td>
        <td>{{ a.date | longDate }}</td>
        <td>
          <span v-for="studentId in a.student" :key="studentId">
            {{ getStudentName(studentId) }}
          </span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'ActivityReport',

  computed: {
    ...mapGetters({
      activities: 'activities/sortedActivities',
      students: 'students/sortedStudents',
      subjects: 'subjects/sortedSubjects'
    })
  },

  mounted () {
    store.dispatch('activities/getActivities', true)
    store.dispatch('students/getStudents', true)
    store.dispatch('subjects/getSubjects', true)
  },

  methods: {
    getStudentName (id) {
      const student = this.students.find(s => s.id === id)

      return student ? student.name : undefined
    },

    getSubjectName (id) {
      const subject = this.subjects.find(s => s.id === id)

      return subject ? subject.name : undefined
    }
  }
}
</script>

<style lang="scss">
.reports__title {
  margin: 1rem auto 2rem;
  text-align: center;
}

.reports__table {
  margin-top: 2rem;
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: .25ch 1ch;
    border: 1px solid #B0BEC5;
    text-align: left;
  }

  span {
    width: 100%;
    display: block;
  }
}
</style>
